import { Table } from "@tanstack/react-table";

const escapeCell = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  const str = typeof value === "string" ? value : String(value);
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const resolveHeader = (header: unknown, fallback: string): string =>
  typeof header === "string" ? header : fallback;

export const exportTableToCsv = <T,>(
  table: Table<T>,
  fileName: string,
): void => {
  const columns = table.getVisibleLeafColumns().filter((c) => c.id !== "select");

  const headerRow = columns
    .map((col) => escapeCell(resolveHeader(col.columnDef.header, col.id)))
    .join(",");

  const bodyRows = table.getRowModel().rows.map((row) =>
    columns
      .map((col) => escapeCell(row.getValue(col.id)))
      .join(","),
  );

  const csv = [headerRow, ...bodyRows].join("\r\n");
  const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
